export default __webpack_public_path__ + "static/media/parkingrampe3.f0fa7228.png";